import styled from "@emotion/styled"
import theme from "../../particles/Theme"

const StyledBottomMenu = styled.div`
  padding: 0;
  background: #fff;
  z-index: 20;

  @media (max-width: ${theme.breakpoints[1]}) {
    display: none;
  }

  .content {
    display: flex;
    justify-content: center;
  }

  .button.menu-button {
    background: #f15d2e;
    color: white;
    padding: 10px 20px;
  }

  .button.menu-button:hover {
    background: ${theme.colors.primaryHover};
  }

  ul {
    width: 100%;
    justify-content: space-between;
    margin: 0;
    padding: 0;

    a:hover {
      color: ${theme.colors.primaryHover};
      transition: color 0.2s ease-in-out;
    }
  }
`

export default StyledBottomMenu
